import {Button} from 'components/generic'
import type {ButtonProps} from 'components/generic'

export const Submit = (props: ButtonProps) => (
  <Button {...props} type="submit">
    <i className="loading icon-spinner-2 animate-spin mr-2 " />
    {props.children}
  </Button>
)
